import { Typography } from '@mui/material'
import clsx from 'clsx'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import logoDRV from '../../../../../assets/Images/drv/drvLogo.svg'
import logoDRVLight from '../../../../../assets/Images/drv/logo-drv-blanco.png'
import { IRootState } from '../../../../../redux/types'
import HiddenMobile from '../../../styles/HiddenMobile'
import { BrandLogo, ContainerClientLogo, ContainerLogo, LineBox, StyledDrawer } from '../../../styles/layouts/MainLayout'
import BrandFilter from '../filters/BrandFilter'
import AdminMenu from './admin/AdminMenu'

// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
function Sidebar({ theme }: { theme: string }) {
  const location = useLocation()

  const { userBrands } = useSelector((state: IRootState) => state.brand)
  const { globalBrandId, globalLineId } = useSelector((state: IRootState) => state.global)

  let isAdmin = location.pathname.includes('admin') || location.pathname === '/escritorio' || location.pathname === '/usuarios/perfil'
  const SelectedContainer = isAdmin ? ContainerLogo : ContainerClientLogo

  const brandLogoURL = isAdmin
    ? userBrands.find((brand: any) => brand.id === globalBrandId)?.light_logo
    : userBrands.find((brand: any) => brand.id === globalBrandId)?.dark_logo

  return (
    <>
      {window.location.pathname !== '/terms' && (
        <HiddenMobile>
          {window.location.pathname !== '/inicio' && (
            <>
              {globalBrandId != null && userBrands.find((brand: any) => brand.id === globalBrandId) !== undefined && (
                <SelectedContainer sx={{ ...(isAdmin && { backgroundColor: '#171A1C' }) }}>
                  <BrandLogo
                    src={`${import.meta.env.VITE_AWS_URL}/brands/${brandLogoURL}`}
                    alt="Logo Marca"
                    sx={{ ...(theme && { color: theme }) }}
                  />
                </SelectedContainer>
              )}
              {globalBrandId == null && (
                <SelectedContainer sx={{ ...(isAdmin && { backgroundColor: '#171A1C' }) }}>
                  <BrandLogo src={isAdmin ? logoDRVLight : logoDRV} alt="drv logo" sx={{ ...(theme && { color: theme }) }} />
                </SelectedContainer>
              )}

              {/* BrandLine name */}
              {globalBrandId != null &&
                globalLineId != null &&
                userBrands
                  .find((brand: any) => brand.id === globalBrandId)
                  .active_lines.find((brandline: any) => brandline.id === globalLineId) !== undefined && (
                  <LineBox sx={{ ...(theme && { color: theme }) }}>
                    <Typography variant="body2">
                      {
                        userBrands
                          .find((brand: any) => brand.id === globalBrandId)
                          .active_lines.find((brandline: any) => brandline.id === globalLineId).name
                      }
                    </Typography>
                  </LineBox>
                )}

              <StyledDrawer classes={{ paper: clsx(theme, globalLineId === null && 'lessMargin') }} variant="permanent" open>
                {theme === 'admin' && <AdminMenu />}

                <BrandFilter layout={theme} />
              </StyledDrawer>
            </>
          )}
        </HiddenMobile>
      )}
    </>
  )
}

export default Sidebar
